import { useQuery } from '@tanstack/react-query';

import { queryClient } from '../components/queryClient';
import { EventsFilter, Fleet } from '../interfaces';
import { useFleet } from '../hooks';
import { fleetCleanFilters, fleetDefaultFilters } from '../constants';
import { AnalyticsService } from '../services';

const queryKey = ['filter'];

export const useEventsFilter = () => {
  const fleet = useFleet();

  const queryFn = () => Promise.resolve<EventsFilter>(fleetDefaultFilters(fleet.uuid));

  return useQuery({
    queryKey,
    queryFn,
    cacheTime: Infinity, // 24h
    staleTime: Infinity, // 24h
    refetchOnWindowFocus: false,
  });
};

export const setEventsFilter = (filter: EventsFilter) => {
  // Put data (or partial data) into cache
  queryClient.setQueryData(queryKey, filter);
};

export const updateFilterPartial = (filter: Partial<EventsFilter>) => {
  const oldFilter = queryClient.getQueryData<EventsFilter>(queryKey) ?? {};

  const newFilter = { ...oldFilter, ...filter };
  queryClient.setQueryData(queryKey, newFilter);
};

export const getFilterData = (): EventsFilter | undefined => {
  return queryClient.getQueryData<EventsFilter>(queryKey);
};

export function setFilter(filter: EventsFilter) {
  AnalyticsService.event('filter', 'update', 'filter');
  setEventsFilter(filter);
}

export function setFilterClean(fleetUUID: Fleet['uuid']) {
  setFilter(fleetCleanFilters(fleetUUID));
}

export function setDefaultFilter(fleetUUID: Fleet['uuid']) {
  AnalyticsService.event('filter', 'update', 'filter');
  setEventsFilter(fleetDefaultFilters(fleetUUID));
}
